const DateTime = {
    Format(data) {
        if (!data)
            return null;

        return new Date(data)
            .toISOString()
            .split("T")[0];
    },

    FormatLocale(data) {
        if (!data)
            return null;

        return new Date(data).toLocaleDateString();
    },

    Now() {
        let date = new Date().toLocaleDateString();
        let split = date.split("/");
        return split[2] + "-" + split[1] + "-" + split[0];
    },

    FormatPtBr() {
        let date = new Date();
        return date.getDate() + "/" + (date.getMonth() + 1).toString().padStart(2, '0') + "/" + date.getFullYear();
    }
};

export default DateTime;
